import {addDays, format, parseISO} from "date-fns";

export {
    isValid,
    parse,
    parseISO,
    formatISO,
    addDays,
    subDays,
    subMonths,
    subYears,
    isBefore,
    isAfter,
    format,
    differenceInDays,
    differenceInHours,
    formatDistanceToNow,
    getUnixTime,
    differenceInYears,
    differenceInSeconds,
    min,
    max,
    addSeconds,
} from "date-fns";

// A week's Monday, `weeksAgo` weeks before the given Monday.
export const weekStartFor = (weekStart: DateValue, weeksAgo: number): DateValue =>
    format(addDays(parseISO(weekStart), -7 * weeksAgo), "yyyy-MM-dd");

// "Aug 17th – 23rd", crossing months as "Jul 27th – Aug 2nd".
export const weekLabel = (weekStart: DateValue) => {
    const start = parseISO(weekStart);
    const end = addDays(start, 6);
    return `${format(start, "MMM do")} – ${format(
        end,
        format(start, "MMM") === format(end, "MMM") ? "do" : "MMM do",
    )}`;
};
